module.exports = __webpack_public_path__ + "img/podlahy-a-dvere.8e753601.svg";